import {Avatar, Space} from "antd";
import {OfferingTitle} from "../../../public-profile/offering/offering-title";
import {PublicProfileOfferingImage} from "../../../public-profile/offering/offering-image";
import {StyledPublicProfileOfferingMainSectionWrapper} from "../../../public-profile/offering/offering.style";
import {ShareOfferingWidget} from "../../../public-profile/offering/share-offering";
import {StyledLiveClassInfoWidget} from "../../../public-profile/offering/product-details/widget/widget-info.style";
import {DollarOutlined, UserOutlined} from "@ant-design/icons";
import {MainProductDetails} from "./about-section";
import {
  sumCustomerPurchaseAddOns,
  TGetCustomerProductDetailApiResponse,
} from "../../../../react-query-hooks/products";
import {StyledLiveClassesHostInfoWidget} from "../../../public-profile/live-classes-section/details/main-details-section.style";
import {
  handleFacebookLink,
  handleMailLink,
  handleProductLink,
  handleTwitterLink,
} from "../../../../utils/products";

type TCustomerProductDetails = {
  productData: TGetCustomerProductDetailApiResponse;
};

export function CustomerProductDetails({productData}: TCustomerProductDetails) {
  const {product, coach, addOns} = productData;
  // v2 resolves the coach's display name server-side.
  const displayName = coach.coachDisplayName;
  const extraParams = {
    facebookLink: handleFacebookLink({
      username: coach.username,
    }),
    twitterLink: handleTwitterLink({
      textContent: `I just purchased a product by  ${displayName} titled ${product.name} on Coachli!`,
      username: coach.username,
    }),
    mailLink: handleMailLink({
      body: `I just purchased a product by ${displayName} titled ${product.name} on Coachli! ${window.location.origin}/${coach.username}`,
      subject: "",
    }),
    copyLink: handleProductLink({
      productId: product.id,
      slug: product.slug,
      username: coach.username,
      tinyUrl: product.tinyUrl,
      windowNav: true,
    }),
  };
  // v2 has no `total`: the add-on prices are already folded into
  // `productData.amount`, so this is shown as an add-on subtotal only.
  const addOnsSubtotal = sumCustomerPurchaseAddOns(addOns);
  return (
    <div>
      <Space
        direction="vertical"
        size={16}
        style={{
          display: "flex",
        }}
      >
        <PublicProfileOfferingImage
          src={product.coverImage || "/images/no-image-placeholder.png"}
          alt={product.name}
        />
        <OfferingTitle title={product.name} />
        <StyledPublicProfileOfferingMainSectionWrapper>
          <div className="offering-main-details-info">
            <MainProductDetails
              assets={productData.assets}
              productDescription={product.description}
              redirectUrl={product.urlRedirect}
            />
          </div>
          <div className="offering-widget-info-content" style={{top: "2rem"}}>
            <div className="widget-flex">
              <div>
                <StyledLiveClassInfoWidget>
                  <Space size={16} direction="vertical" style={{display: "flex"}}>
                    <h2 style={{fontSize: "2rem", fontWeight: 700}}>Price</h2>
                    <div>
                      <div className="offering-content-item ">
                        <Space size={10}>
                          <DollarOutlined style={{color: "#222222"}} />
                          {productData.amount < 1 ? (
                            <span className="booking-info-content-item-value">Free</span>
                          ) : (
                            <span className="booking-info-content-item-value">
                              {`${
                                productData.currency
                              } ${productData.amount.toLocaleString()}`}
                            </span>
                          )}
                        </Space>
                      </div>
                    </div>
                    {/* Purchases made before v2 started recording the selected
                        options come back with an empty list — render nothing. */}
                    {addOns.length > 0 && (
                      <div>
                        <h3 style={{fontWeight: 600}}>Add-ons</h3>
                        <ul style={{margin: 0, paddingLeft: "1.6rem"}}>
                          {addOns.map((addOn) =>
                            addOn.options.map((option) => (
                              <li key={option.id}>
                                {`${addOn.variantName} - ${option.optionName}`}
                                {option.price > 0 &&
                                  ` (${
                                    option.currency
                                  } ${option.price.toLocaleString()})`}
                              </li>
                            ))
                          )}
                        </ul>
                        {addOnsSubtotal > 0 && (
                          <p style={{marginTop: "0.8rem"}}>
                            {`Add-ons subtotal: ${
                              productData.currency
                            } ${addOnsSubtotal.toLocaleString()}`}
                          </p>
                        )}
                      </div>
                    )}
                  </Space>
                </StyledLiveClassInfoWidget>
              </div>
              <StyledLiveClassesHostInfoWidget>
                <h2 className="host-heading-text">Created by</h2>
                <div className="host-info-wrapper">
                  <div className="host-avatar-wrapper">
                    {coach.profilePhoto ? (
                      <Avatar size={87} src={coach.profilePhoto} />
                    ) : (
                      <Avatar size={87} icon={<UserOutlined />} />
                    )}
                  </div>
                  <div className="host-name-info-wrapper">
                    <p className="host-name">{`${displayName}`}</p>
                    <p className="host-role">{`${coach.shortBio}`}</p>
                  </div>
                </div>
              </StyledLiveClassesHostInfoWidget>
              <ShareOfferingWidget title="Share product via" extraParams={extraParams} />
            </div>
          </div>
        </StyledPublicProfileOfferingMainSectionWrapper>
      </Space>
    </div>
  );
}
